<template>
    <section v-if="hasPermissions(['Utilities-Walking-Number-Update Read'])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            {{ title_page }}
        </h1>
        <div class="view__description">
            <p class="view__description__text">
                This is where you can change the Walking # of Rooms. Select a building, a level and an area. Then enter the appropriate walking #.
            </p>
        </div>

        <div class="row mb-0">
            <div class="col-md-8 pt-0">
                <div class="row mb-0">
                    <div class="col-md-8 pt-0">
                        <div class="row mb-0 no-gutters">
                            <div class="col-12">
                                <div class="row no-gutters mb-0">
                                    <form class="w-100">
                                        <FormDynamic
                                            :form_format="form_format"
                                            :form_data="form_data"
                                            :array_options="array_options"
                                            :for_update="false"
                                            :content_align_x="'no-justify'"
                                        />
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="tab-content">
            <div class="tab-pane fade active show" id="listation">
                <div class="row mb-0 no-gutters">
                    <div class="col-lg-12">
                        <v-card>
                            <DinamicTableInfiniteLoader
                                :headers="table_headers"
                                :items="rooms"
                                :search="search"
                                @emitToUpdate="modal_update($event)"
                                :array_options_table="array_options_table"
                                @live_edition="live_edition($event)"
                                @fetchMainList="fetchMainList($event)"
                                ref="main_table"
                            />
                        </v-card>
                    </div>
                </div>
            </div>
        </div>
        <WaitingModal/>
    </section>
   <div v-else>
        <UnauthorizedComponent :breadcrumb="breadcrumb"/>
    </div>
</template>

<script>

import FormResources    from    './form_resources'
import FormDynamic      from    '@/components/FormDynamic.vue'
import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal     from    '@/components/WaitingModal'
import UnauthorizedComponent from   '@/components/UnauthorizedComponent'
import Resources        from    './resources'
import 'vuetify/dist/vuetify.min.css'

import { Notyf }            from    'notyf';
import 'notyf/notyf.min.css'; // for React and Vue
import DinamicTableInfiniteLoader from '../../DinamicTableInfiniteLoader.vue'
const notyf = new Notyf({
    duration: 8000,
});

export default {

    name: 'WalkingNumberUpdate',

    components: {
    Breadcrumb,
    WaitingModal,
    FormDynamic,
    UnauthorizedComponent,
    DinamicTableInfiniteLoader
},
    
    data() 
    {
        return {
            notyf,
            title_page:         'Walking Number Update',
            content_header:     this.$store.state.headers,
            rest_api:           `walking_number`,
            rest_api_pagination: `walking_number_pagination`,
            notifications:      this.$store.state.form_notyf,
            table_headers:      Resources.table_headers,
            breadcrumb:         Resources.breadcrumb,
            form_data:          FormResources.form_data,
            form_format:        FormResources.form_format,
            add_btn:            'Add Survey',
            single_select:      false,
            table_selection:    [],
            search:             '',
            global_index:       '',
            single_object:      {},
            levels:             [],
            areas:              [],
            rooms:              [],
            rooms_cache:        [],
            array_options:      {},
            pagination: null,
        }
    },

    watch:{

        'form_data.building_id'(val)
        {
            if(val){
                this.array_options.level_id = this.levels.filter( (item) => { return item.building_id === val } )
                this.array_options.level_id.length ? notyf.success('Levels available') : notyf.error('No levels available for the selected building')
            }
            this.form_data.level_id = ''
            this.form_data.area_id = ''
            this.array_options.area_id = []
            this.rooms = []
            
        },

        'form_data.level_id'(val)
        {
            if(val){
                this.array_options.area_id = this.areas.filter( (item) => { return item.level_id === val } )
                this.array_options.area_id.length ? notyf.success('Areas available') : notyf.error('No areas available for the selected level')
            }
            this.form_data.area_id = ''
            this.rooms = []
        },

        'form_data.area_id'(val)
        {
            if(val)
            {
                this.fetchMainList()
            }
            else
            {
                this.rooms = []
            }
        },

    },

    methods: 
    {

        async live_edition({i:index, item:value})
        {
            if(value.walking_number === ''){
                notyf.error('Walking # cannot be empty')
                return false
            }
            if(isNaN(value.walking_number)){
                notyf.error('Walking # only can be numeric characters')
                return false
            }
            if(value.walking_number > 1000000000){
                notyf.error('Walking # cannot be higher than 1.000.000.000')
                return false
            }
            await this.status_update(value.id, value, index, this.rest_api)
        },

        async fetchMainList(params = {}) 
        {
            params['area_id'] = this.form_data.area_id
            this.rooms = [];
            await this.showLoader()
            await this.apiRequest(params, true)
        },

        async loadMoreRecords(data, reset_list)
        {
            if(reset_list)
            {
                this.rooms = []
            }

            if(data.pagination.data.length)
            {
                data.pagination.data.forEach((item) => {
                    this.rooms.push(item)
                })
            }
            this.pagination = data.pagination

            await this.hideLoader(data.pagination.data)
        },

        async showLoader()
        {
            this.$refs.main_table.showLoader()
        },

        async hideLoader(data)
        {
            this.$refs.main_table.hideLoader(data)
        },

        splice_object(splicing_object)
        {
            this.rooms.splice(splicing_object.index, 1, splicing_object.single_object)
        },

        fill_data(data)
        {
            this.array_options = {
                building_id:    data.buildings,
            }
            this.levels         = data.levels
            this.areas          = data.areas
        },

    },

    async mounted()
    {
        if(this.hasPermissions(['Utilities-Walking-Number-Update Read']))
        {
            await this.api_request()
        }
    }

}

</script>

